import { render, staticRenderFns } from "./PreviewEventCarousel.vue?vue&type=template&id=47383bd6"
import script from "./PreviewEventCarousel.vue?vue&type=script&lang=js"
export * from "./PreviewEventCarousel.vue?vue&type=script&lang=js"
import style0 from "./PreviewEventCarousel.vue?vue&type=style&index=0&id=47383bd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports